/* Lagerverkauf Manching — Homepage-Zusatzbereiche: Öffnungsstatus + Städte-Routen */
(function(){
  "use strict";
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;

  function lvState(){
    var now=new Date(), day=now.getDay(), mins=now.getHours()*60+now.getMinutes();
    var OPEN=600, CLOSE=1020, biz=(day>=1&&day<=6);
    if(biz&&mins>=OPEN&&mins<CLOSE){
      var rem=CLOSE-mins, rh=Math.floor(rem/60), rm=rem%60;
      if(mins>=960) return {open:true,dot:'#E8A100',text:'Letzte Chance heute · noch '+(rh>0?rh+' Std ':'')+rm+' Min offen'};
      return {open:true,dot:'#377E62',text:'Jetzt geöffnet · noch '+rh+' Std '+rm+' Min'};
    }
    var t;
    if(day===0) t='Sonntags Pause · wir sehen uns Mo wieder ;-)';
    else if(day===6&&mins>=CLOSE) t='Heute geschlossen · Mo ab 10 Uhr wieder für dich da';
    else if(biz&&mins<OPEN) t='Gleich geöffnet · heute ab 10 Uhr';
    else t='Heute geschlossen · morgen ab 10 Uhr für dich da';
    return {open:false,dot:'#9a948a',text:t};
  }
  function paintStatus(){
    var s=lvState();
    document.querySelectorAll('[data-lv-status]').forEach(function(el){
      var dot=el.querySelector('[data-lv-dot]'), txt=el.querySelector('[data-lv-text]');
      if(dot){dot.style.background=s.dot; if(!s.open) dot.style.animation='none'; else dot.style.animation='';}
      if(txt) txt.textContent=s.text;
    });
  }
  paintStatus(); if(!reduce) setInterval(paintStatus,60000);

  /* Heute-Markierung in der Öffnungszeiten-Tabelle */
  var today=new Date().getDay();
  document.querySelectorAll('[data-hours]').forEach(function(tbl){
    var row=tbl.querySelector('tr[data-day="'+today+'"]');
    if(row){row.classList.add('today'); row.cells[0].insertAdjacentHTML('beforeend','<span class="today-tag">HEUTE</span>');}
  });

  /* Städte-Fahrzeit → Route-Button anpassen */
  document.querySelectorAll('[data-chips]').forEach(function(box){
    var routeBtn=document.querySelector('[data-routebtn]');
    box.querySelectorAll('.chip').forEach(function(c){
      c.addEventListener('click',function(){
        box.querySelectorAll('.chip').forEach(function(x){x.classList.remove('active');});
        c.classList.add('active');
        if(routeBtn){
          routeBtn.href='https://www.google.com/maps/dir/'+c.dataset.city+'/Weberstra%C3%9Fe+10,+85077+Manching';
          var lbl=routeBtn.querySelector('[data-routelabel]');
          if(lbl) lbl.textContent='Nur '+c.dataset.min+' Min – das lohnt sich';
        }
      });
    });
  });
})();
